import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ImagilityBaseResponse } from 'app-models';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class JobDescriptionLcaPositionLibraryService {

  constructor(private http:HttpClient) { }


  getLcaDetailsBylcaId(lcaId) {
    return this.http.get(`/dashboard/petitioner/lca/${lcaId}`).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          return response.data;
        }
      })
    );
  }
  
}
